import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, MapPin, MessageCircle, HeartHandshake, Search, Check } from 'lucide-react';
const benefits = [{
  icon: <ShieldCheck size={40} data-id="element-57" />,
  title: 'Cobertura Real. No Solo Una Tarjeta.',
  description: 'Nos aseguramos de que entiendas exactamente qué está cubierto — y qué no — antes de firmar cualquier cosa.'
}, {
  icon: <MapPin size={40} data-id="element-58" />,
  title: 'Un Agente Local Que Conoce Tampa',
  description: 'No estamos en un centro de llamadas a tres estados de distancia. Estamos en tu comunidad. Entendemos los riesgos, los vecindarios, las necesidades de las familias de Tampa.'
}, {
  icon: <MessageCircle size={40} data-id="element-59" />,
  title: 'Seguros en Tu Idioma',
  description: 'Atendemos a familias de habla inglesa y española con igual cuidado y claridad. Sin confusión. Sin malentendidos. Aquí te entendemos.'
}, {
  icon: <HeartHandshake size={40} data-id="element-60" />,
  title: 'Una Relación Que Dura',
  description: 'Estamos aquí cuando tienes preguntas. Estamos aquí cuando la vida cambia. Estamos aquí cuando necesitas presentar un reclamo y necesitas a alguien de tu lado.'
}, {
  icon: <Search size={40} data-id="element-61" />,
  title: 'Opciones de Múltiples Aseguradoras',
  description: 'Compramos el mercado por ti — encontrándote la cobertura correcta al precio correcto. No solo las opciones de una compañía. Las mejores opciones para ti.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="py-14 md:py-20 bg-white" data-id="element-62">
      <div className="container mx-auto px-4" data-id="element-63">
        <div className="max-w-5xl mx-auto" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-65">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy mb-6" data-id="element-66">
              LO QUE ANGEL INSURANCE TE DA
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto" data-id="element-67"></div>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="space-y-6" data-id="element-68">
            {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-off-white p-6 md:p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow flex flex-col md:flex-row items-start gap-6" data-id="element-69">
                <div className="bg-navy text-gold p-4 rounded-xl shrink-0" data-id="element-70">
                  {benefit.icon}
                </div>
                <div data-id="element-71">
                  <h3 className="text-xl md:text-2xl font-bold text-navy mb-3 flex items-center gap-2" data-id="element-72">
                    <Check size={20} className="text-gold shrink-0" data-id="element-73" />{' '}
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-74">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}